// Regular expressions for validation
const stateRegex = /^[A-Z]{2}$/;
const zipRegex = /^\d{5,}$/; // Zip code must be at least 5 digits

// Generic form change handler
export const handleGenericFormChange = (e, setFormState) => {
  const { name, value } = e.target;
  setFormState((prevForm) => ({ ...prevForm, [name]: value }));
};

// Handle role change in contact assignments
export const handleRoleChangeUtil = (
  e,
  index,
  roleKey,
  assignedContacts,
  setAssignedContacts
) => {
  const value = e.target.checked;
  const updatedContacts = [...assignedContacts];
  updatedContacts[index][roleKey] = value;
  setAssignedContacts(updatedContacts);
};

export const validateManagementForm = (formData) => {
  const errors = {};

  // Required field validation
  if (!formData.companyName || formData.companyName.trim() === "") {
    errors.companyName = "Company Name is required";
  }
  if (
    !formData.statusId ||
    formData.statusId === "" ||
    formData.statusId === 0
  ) {
    errors.statusId = "Status is required";
  }
  if (!formData.address || formData.address.trim() === "") {
    errors.address = "Address is required";
  }
  if (!formData.city || formData.city.trim() === "") {
    errors.city = "City is required";
  }
  if (!formData.state || formData.state.trim() === "") {
    errors.state = "State is required";
  }
  if (!formData.zip || formData.zip.trim() === "") {
    errors.zip = "Zip is required";
  }

  // State validation
  if (formData.state && !stateRegex.test(formData.state)) {
    errors.state = 'State must be exactly 2 uppercase letters (e.g., "NY")';
  }

  // Zip code validation
  if (formData.zip && !zipRegex.test(formData.zip)) {
    errors.zip = "Zip code must be at least 5 digits";
  }

  return errors;
};

export const validateContactForm = (formData) => {
  const errors = {};

  // Required field validation
  if (!formData.contactName || formData.contactName.trim() === "") {
    errors.contactName = "Name is required";
  }
  if (!formData.phone1 || formData.phone1.trim() === "") {
    errors.phone1 = "Primary Phone Number is required";
  }
  if (!formData.emailAddress || formData.emailAddress.trim() === "") {
    errors.emailAddress = "Email Address is required";
  }
  if (
    formData.contactLevel == null ||
    formData.contactLevel === "" ||
    formData.contactLevel === 0
  ) {
    errors.contactLevel = "Contact Level is required";
  }

  // Zip code validation
  if (formData.zip && !zipRegex.test(formData.zip)) {
    errors.zip = "Zip code must be at least 5 digits";
  }

  // State validation
  if (formData.state && !stateRegex.test(formData.state)) {
    errors.state = 'State must be exactly 2 uppercase letters (e.g., "NY")';
  }

  return errors;
};

export const validateCustomerForm = (formData) => {
  const errors = {};

  // Required field validation
  if (!formData.customerName) {
    errors.customerName = "Customer Name is required";
  }
  if (!formData.customerNumber) {
    errors.customerNumber = "Customer Number is required";
  }
  if (!formData.address) {
    errors.address = "Address is required";
  }
  if (!formData.city) {
    errors.city = "City is required";
  }
  if (!formData.state) {
    errors.state = "State is required";
  }
  if (!formData.zip) {
    errors.zip = "Zip is required";
  }

  // Zip code validation
  if (formData.zip && !zipRegex.test(formData.zip)) {
    errors.zip = "Zip code must be at least 5 digits";
  }

  // State validation
  if (formData.state && !stateRegex.test(formData.state)) {
    errors.state = 'State must be exactly 2 uppercase letters (e.g., "NY")';
  }

  return errors;
};
